// extracted by mini-css-extract-plugin
export default {"section-not-found":"not-found_section-not-found__MArzE","text404":"not-found_text404__F4H7z","btn-go-back":"not-found_btn-go-back__F41t2"};